import React, { useEffect } from "react";
import logo from "../../images/logo.jpg";
import { AppBar, Grid, IconButton } from "@mui/material";
import { Logout } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { darkColor } from "../costant";
import useStore from "../../State";

const Header: React.FC = () => {
  const navigate = useNavigate();

  const setLoggedIn = useStore((state: any) => state.setLoggedIn);
  const loggedIn = useStore((state: any) => state.loggedIn);
  useEffect(() => {
    if (!loggedIn) navigate("/login");
  }, [loggedIn]);

  return (
    <AppBar position="static" style={{ backgroundColor: darkColor }}>
      <Grid container alignItems="center" style={{ padding: "4px 16px" }}>
        <img
          src={logo}
          alt="logo"
          style={{ width: "50px" }}
          onClick={() => navigate("/home")}
        />
        <Grid item xs />
        <IconButton
          onClick={() => {
            setLoggedIn(false);
            navigate("/login");
          }}
        >
          <Logout style={{ color: "white" }} />
        </IconButton>
      </Grid>
    </AppBar>
  );
};

export default Header;
